import React from "react";
import { Link } from "react-router-dom";
import { ReactComponent as ExternalLinkIcon } from "../static/external-link-svgrepo-com.svg";

function AppCard({
  app,
  onScreenshotKeyDown,
  setScreenshotRowRef,
  onOpenLightbox,
  hideWebsiteLink = false,
  showContactLink = false,
  contactEmail = "carlosmsilva83@gmail.com",
}) {
  const hasInternalWebsiteLink = !hideWebsiteLink && Boolean(app.websitePath);
  const hasExternalWebsiteLink = !hideWebsiteLink && Boolean(app.websiteUrl);
  const hasPrivacyLink = Boolean(app.privacyPolicyUrl);
  const hasContactLink = showContactLink && Boolean(contactEmail);
  const tags = Array.isArray(app.tags) ? app.tags : [];
  const hasScreenshots = Array.isArray(app.screenshots) && app.screenshots.length > 0;
  const privacyPolicyHref = app.privacyPolicyUrl
    ? app.privacyPolicyUrl.startsWith("http")
      ? app.privacyPolicyUrl
      : `/#${app.privacyPolicyUrl}`
    : null;
  const hasLinks = Boolean(
    app.appStoreUrl ||
      hasInternalWebsiteLink ||
      hasExternalWebsiteLink ||
      hasPrivacyLink ||
      hasContactLink
  );
  const hasActions = hasLinks || tags.length > 0;

  return (
    <article className={`app-card${hasActions ? " app-card--with-actions" : ""}`}>
      <h3>
        <img
          src={app.icon}
          alt={`${app.title} icon`}
          width="56"
          height="56"
          loading="lazy"
          decoding="async"
        />
        <span>{app.title}</span>
      </h3>
      {hasActions ? (
        <div className="app-links">
          {app.appStoreUrl ? (
            <a
              className="app-card-link"
              href={app.appStoreUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>App Store</span>
              <ExternalLinkIcon
                className="external-link-icon"
                aria-hidden="true"
                focusable="false"
              />
            </a>
          ) : null}
          {hasInternalWebsiteLink ? (
            <Link className="app-card-link" to={app.websitePath}>
              <span>Website</span>
            </Link>
          ) : null}
          {hasExternalWebsiteLink ? (
            <a
              className="app-card-link"
              href={app.websiteUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>Website</span>
              <ExternalLinkIcon
                className="external-link-icon"
                aria-hidden="true"
                focusable="false"
              />
            </a>
          ) : null}
          {hasPrivacyLink ? (
            <a
              className="app-card-link"
              href={privacyPolicyHref}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>Privacy Policy</span>
              <ExternalLinkIcon
                className="external-link-icon"
                aria-hidden="true"
                focusable="false"
              />
            </a>
          ) : null}
          {hasContactLink ? (
            <a className="app-card-link" href={`mailto:${contactEmail}`}>
              <span>Contact Us</span>
            </a>
          ) : null}
          {tags.map((tag) => (
            <span className="app-card-tag" key={`${app.id}-tag-${tag}`}>
              {tag}
            </span>
          ))}
        </div>
      ) : null}
      <p>{app.description}</p>
      {hasScreenshots ? (
        <div className="app-screenshots-gallery">
          <ul
            className="app-screenshots"
            aria-label={`${app.title} screenshots`}
            tabIndex="0"
            onKeyDown={(event) => onScreenshotKeyDown(app.id, event)}
            ref={(node) => setScreenshotRowRef(app.id, node)}
          >
            {app.screenshots.map((screenshot, index) => (
              <li className="screenshot-item" key={`${app.id}-shot-${index + 1}`}>
                <button
                  type="button"
                  className="screenshot-trigger"
                  onClick={() => onOpenLightbox(app.id)}
                  aria-label={`Open ${app.title} screenshot ${index + 1} in full screen`}
                >
                  <img
                    className="screenshot-image"
                    src={screenshot}
                    alt={`${app.title} screenshot ${index + 1}`}
                    loading="lazy"
                    decoding="async"
                  />
                </button>
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </article>
  );
}

export default AppCard;
